import React, { useEffect, useState } from 'react'
import { Icon, Modal } from 'semantic-ui-react';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';


const Historial =()=>{
    const [db] = useState(firebase.firestore().collection('Vales'))

    useEffect(()=>{
        db.where('tipo', '==', 'combustible').onSnapshot(querySnapshot =>{
			const datos = []
			querySnapshot.forEach(doc=>{
				//const previousAct = this.state.actividades;
				datos.push({
					id: doc.id,
					nombre: doc.data().nombre,
					categoria: doc.data().categoria,
					pagarpor: doc.data().pagarpor,
					precioMin: doc.data().precioMin,
					precioMid: doc.data().precioMid,
					precioMax: doc.data().precioMax,
					frecuencia: doc.data().frecuencia,
				})
			})
		})
    },[])
    return(
        <div>

        </div>
    )
}

export default Historial